<template>
  <modal :open="internalOpen" :width="1200">
    <template #header>
      <modal-header variant="cross" @cancel="closeModal()">
        <h1>{{ t("pages.driver.historyList.showAttachmentComment.title") }}</h1>
      </modal-header>
    </template>
    <cards class="flex flex-col gap-12 w-full">
      <Card v-for="(photo, index) in photos" :key="photo.id" class="w-full">
        <div class="relative">
          <h2>{{ photo?.file?.originalFileName }} {{ (photo?.file?.size / 1000000)?.toFixed(2) }} MB</h2>
          <hr class="my-4 border-t border-gray-300">
          <Image
            :key="'attachment-' + index"
            alt="Photo"
            :src="photo?.file?.contentUrl"
            :enlargeable="true"
            :rotation-enabled="true"
            :file-entity="photo?.file"
          />
        </div>
      </Card>
    </cards>
  </modal>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useVModel } from '@vueuse/core';
import { useI18n } from 'vue-i18n';
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import Card from '@utils/Card.vue';
import Cards from '@utils/Cards.vue';
import Image from '@utils/Image.vue';
import type { Driver, DriverCommentAttachment } from '@/entities/Entities';

interface Props {
  open: boolean;
  driver: Driver;
  editDriverComment: {
    driver: Driver | null;
    attachments: DriverCommentAttachment[];
    author: null | string;
    type: null | string;
    text: null | string;
    id: string | null;
    createdAt: Date | null;
  };
}

const emit = defineEmits(['update:open']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);

const photos = computed(() => props.editDriverComment?.attachments
  ?.filter((attachment) => attachment.file));

const { t } = useI18n();

function closeModal() {
  internalOpen.value = false;
}
</script>

<style lang="scss" scoped>
:deep(img.rotation-enabled) {
  transform: rotate(var(--rotation)) !important;
}
</style>
